import { render, staticRenderFns } from "./knowType.vue?vue&type=template&id=98b1fcfa&scoped=true&"
import script from "./knowType.vue?vue&type=script&lang=js&"
export * from "./knowType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b1fcfa",
  null
  
)

export default component.exports